<header id="page-topbar" (window:scroll)="windowScroll()">
    <div class="layout-width">
        <div class="navbar-header">
            <div class="d-flex">
                <!-- LOGO -->
                <div class="navbar-brand-box horizontal-logo">
                    <a routerLink="/" class="logo logo-dark">
                        <span class="logo-sm">
                            <img src="assets/images/logo-sm.png" alt="" height="22">
                        </span>
                        <span class="logo-lg">
                            <img src="assets/images/logo-dark.png" alt="" height="22">
                        </span>
                    </a>

                    <a routerLink="/" class="logo logo-light">
                        <span class="logo-sm">
                            <img src="assets/images/logo-sm.png" alt="" height="22">
                        </span>
                        <span class="logo-lg">
                            <img src="assets/images/logo-light.png" alt="" height="22">
                        </span>
                    </a>
                </div>

                <button type="button" class="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger shadow-none" id="topnav-hamburger-icon" (click)="toggleMobileMenu($event)">
                    <span class="hamburger-icon">
                        <span></span>
                        <span></span>
                        <span></span>
                    </span>
                </button>
            </div>

            <div class="d-flex align-items-center leftGap">
                <div dropdown class="dropdown topbar-head-dropdown ms-1 header-item" id="notificationDropdown" *ngIf="currentuser">
                    <button dropdownToggle type="button" class="btn btn-icon btn-topbar btn-ghost-dark rounded"
                        id="page-header-notifications-dropdown" data-bs-toggle="dropdown" data-bs-auto-close="outside"
                        aria-haspopup="true" aria-expanded="false">
                        <i class='bi bi-bell fs-2xl'></i>
                        <span class="position-absolute topbar-badge fs-3xs translate-middle badge rounded-pill bg-danger">
                            <span class="notification-badge">{{newNotify}}</span>
                        </span>
                    </button>
                    <div *dropdownMenu class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                        aria-labelledby="page-header-notifications-dropdown" style="border: none;">
                
                        <div *ngIf="totalNotify !== 0" class="dropdown-head rounded-top dropdown-body"
                            style="max-height: 400px; overflow-y: auto; text-align: inherit;">
                            <div class="p-3 border-bottom border-bottom-dashed divCon" *ngFor="let notification of notifications" [class.unread]="!notification.isRead">
                                <div class="taskDiv">
                
                                    <div class="task-title">
                                        {{ notification.title }}
                                    </div>
                
                                    <div class="task-content">
                                        {{ notification.message }}
                                    </div>
                
                                    <div class="task-meta" style="margin-top: 10px;">
                                        <span class="task-date">
                                            {{ notification.creationTime | date:'yyyy/MM/dd' }}
                                        </span>
                
                                        <span class="task-time">
                                            {{ notification.creationTime | date:'hh:mm a' }}
                                        </span>
                                    </div>
                
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div dropdown class="dropdown topbar-head-dropdown ms-1 header-item" id="settingsDropdown">
                    <button dropdownToggle type="button" class="btn btn-icon btn-topbar btn-ghost-dark rounded" id="page-header-settings-dropdown" 
                    data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-haspopup="true" aria-expanded="false" (click)="toggleLanguage()">
                        <i class='bi bi-globe2 fs-2xl'></i>
                    </button>

                    <div *dropdownMenu class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0" aria-labelledby="page-header-settings-dropdown" style="border: none;">
                        <div class="dropdown-head rounded-top dropdown-body" style="overflow-y: auto;text-align: inherit;">
                        </div>
                    </div>
                </div>

                <div dropdown class="dropdown ms-sm-3 header-item topbar-user" *ngIf="currentuser">

                    <div dropdownToggle class="profile" id="page-header-user-dropdown" id="page-header-auth-dropdown" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-haspopup="true" aria-expanded="false">
                        <img class="rounded-circle header-profile-user" [src]="currentuser.photo ? (baseService.imgUrl + currentuser.photo) : 'assets/images/users/UserAvatarPlaceholder.jpg'" (error)="handleImgError($event)"
                         alt="profilepicplaceholder" style="object-fit: cover;">
                        <span class="accountName">{{currentuser.fullName}}</span>
                        <i class="ph-caret-down"></i>
                    </div>

                    <div *dropdownMenu class="dropdown-menu dropdown-menu-end  p-0" aria-labelledby="page-header-auth-dropdown">
                        <div class="dropdown-head  rounded-top">
                            <div class="p-3 border-bottom border-bottom-dashed" style="display: flex;flex-direction: column;gap: 10px;">
                                <a class="dropdown-item" routerLink="/app/profile-view"><i class="ph-user"></i> <span class="align-middle">{{'profile' | translate}}</span></a>
                                <a class="dropdown-item logoutItem" (click)="logout()"><i class="ph-sign-out"></i> <span class="align-middle">{{'logout' | translate}}</span></a>
                            </div>
                        </div>
                    </div>
                </div>

                <button *ngIf="!currentuser" class="action-btn primary-btn" routerLink="/auth/login">{{'login' | translate}}</button>
                <button *ngIf="!currentuser" class="action-btn secondary-btn" routerLink="/auth/register" style="margin: 0 5px;">{{'register' | translate}}</button>
            </div>
        </div>
    </div>
</header>